// @ts-nocheck
import React, { createRef } from "react";
import BaseComponent from "../../../../../base/common/BaseComponent";
import ProcedureBlock from "../../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../../sections/taskInfoSections";
import ProcedureInformation from "../../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ReadOnlyProcedureFileSection from "../../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ActiveShareTaskReadOnly from "../../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import styles from "../../style/index.module.scss";
import StepService from "../../../../../service/stepBase/StepService";
import CompleteStepBusinessType from "../../../../../service/stepBase/completeStepBusinessType";

const procedureFileRef = createRef();
export default class BaseNewSupportingFileComplete extends BaseComponent {
  handleReturnSupportingFileSection = () => {
    // this is an empty function
  };

  handleReturnRejectReason = () => {
    // this.is an empty function
  };

  handleReturnPageName = () => {
    // this is an empty function
  };

  handleSupportingFilePageHeader = () => {
    const { receiveDate, requestByName } = this.props.pageProps;

    return (
      <PageHeader
        title={this.handleReturnPageName()}
        receiveDate={this._formateDate(receiveDate)}
        requestBy={requestByName}
        status="Complete"
      />
    );
  };

  handleSupportingFileTaskInformationSection = (params: any) => {
    const { taskInfoData } = this.props.sectionProps;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInfoData} />}
        testid="task-info-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setTaskInfoData,
            this.setError,
            [CompleteStepBusinessType.taskInfo],
            StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey])
          );
        }}
      />
    );
  };

  handleSupportingFileProcedureFileSection = (params: any) => {
    const { fileTableData, jbProcedureSavedIn } = this.props.sectionProps;

    return (
      <ProcedureBlock
        child={
          <ReadOnlyProcedureFileSection
            procedureFileRef={procedureFileRef}
            clientServerPath={this.props.serverPathValue}
            savedInRadioValue={this.props.savedInRadioValue}
            procedureFileData={fileTableData !== undefined ? fileTableData : []}
            jbProcedureSavedIn={jbProcedureSavedIn}
          />
        }
        testid="procedure-file-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setProcedureFileData,
            this.setError,
            [CompleteStepBusinessType.procedureFile],
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.procedureFile.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleSupportingFileSection = () => {
    return (
      <ProcedureBlock
        className={styles.approveSupportingFile}
        child={this.handleReturnSupportingFileSection()}
        testid="supporting-file-block-arrow"
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  handleSupportingFileProcedureInformationSection = (params: any) => {
    const { procedureStatus } = this.props.pageProps;
    const { procedureInfoData, ppoList } = this.props.sectionProps;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            isShowActions={false}
            noteDisabled={true}
            ppoList={ppoList}
            procedureStatus={procedureStatus}
            isPPODisabled={true}
            submitData={procedureInfoData}
            title="Procedure Information"
          />
        }
        testid="procedure-info-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setProcedureInfoData,
            this.setError,
            [
              CompleteStepBusinessType.procedureOwner,
              CompleteStepBusinessType.pmpExcluded,
              CompleteStepBusinessType.primaryProcedureOwner,
            ],
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.procedureOwner.settingKey,
              CompleteStepBusinessType.pmpExcluded.settingKey,
              CompleteStepBusinessType.primaryProcedureOwner.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleSupportingFileShareTaskSection = (params: any) => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<ActiveShareTaskReadOnly shareTaskData={this.props.shareTaskData} />}
        testid="share-task-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setShareTaskData,
            this.setError,
            [CompleteStepBusinessType.shareTask],
            StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.shareTask.settingKey])
          );
        }}
      />
    );
  };

  render() {
    const params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };
    return (
      // @ts-ignore
      <div className={styles.approveNewPro}>
        {this.handleSupportingFilePageHeader()}
        {this.handleSupportingFileTaskInformationSection(params)}
        {this.handleSupportingFileProcedureFileSection(params)}
        {this.handleSupportingFileSection()}
        {this.handleSupportingFileProcedureInformationSection(params)}
        {this.handleSupportingFileShareTaskSection(params)}
        {/* @ts-ignore */}
        {this.handleReturnRejectReason()}
      </div>
    );
  }
}
